import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '@/stores/hooks';
import { useDispatch } from 'react-redux';
import { useAlert } from '@/hooks/useAlert';
import { useTranslation } from 'react-i18next';
import { langPath } from '@/utils/langPath';

const EXCLUDED_PATHS = [langPath('/login')]; // 가드 제외 경로
export const NavigationGuard = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const lastLocation = useRef(location);
  const { putPartnerServiceOptions } = useAppSelector((state) => state.service);
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const alertShown = useRef(false);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    // 로그인은 가드 제외
    if (EXCLUDED_PATHS.includes(location.pathname)) {
      alertShown.current = false;
      lastLocation.current = location;
      return;
    }
    const hasEditedService = Object.values(putPartnerServiceOptions).some(
      (v) => v != null
    );

    if (!hasEditedService) {
      alertShown.current = false;
      lastLocation.current = location;
      return;
    }

    if (
      location.pathname !== lastLocation.current.pathname &&
      !alertShown.current
    ) {
      alertShown.current = true;

      showAlert({
        message: t('chooseTheServiceToProvideToThePlayer'),
        onConfirm: () => {
          lastLocation.current = location;
        },
      });

      navigate(lastLocation.current.pathname, { replace: true });
    }
  }, [
    location,
    putPartnerServiceOptions,
    showAlert,
    navigate,
    t,
    i18n.language,
  ]);

  return <>{children}</>;
};
